import { render, staticRenderFns } from "./Add_typegroup.vue?vue&type=template&id=9d0060f8&"
import script from "./Add_typegroup.vue?vue&type=script&lang=js&"
export * from "./Add_typegroup.vue?vue&type=script&lang=js&"
import style0 from "./Add_typegroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports